import { render, staticRenderFns } from "./ForceRestore.vue?vue&type=template&id=427c0240&scoped=true"
import script from "./ForceRestore.vue?vue&type=script&lang=ts"
export * from "./ForceRestore.vue?vue&type=script&lang=ts"
import style0 from "./ForceRestore.vue?vue&type=style&index=0&id=427c0240&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427c0240",
  null
  
)

export default component.exports